import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import ReactModal from 'react-modal'
import { Motion, spring } from 'react-motion'
import { ElevatedButton } from 'components/layout'
import { alert } from 'redux/modules/app'
import styles from './alert.styl'

const resetStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    zIndex: 40
  },
  content: {
    position: 'absolute',
    top: '40px',
    left: '5px',
    right: '5px',
    bottom: '40px',
    border: 'none',
    background: 'transparent',
    overflow: 'visible',
    WebkitOverflowScrolling: 'touch',
    borderRadius: 0,
    outline: 'none',
    padding: '20px'
  }
}

@connect(
  state => ({
    alertObj: state.app.alert
  }),
  { alert }
)
class Alert extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    onSubmit: PropTypes.func,
    onClose: PropTypes.func,
    alertObj: PropTypes.object,
    alert: PropTypes.func.isRequired,
    contentLabel: PropTypes.string,
    closeAction: PropTypes.string,
    intlKey: PropTypes.string,
    actionIntl: PropTypes.string,
    cancelActionIntl: PropTypes.string,
    action: PropTypes.string,
    text: PropTypes.string
  }

  static defaultProps = {
    text: 'Are you sure?',
    intlKey: 'notifications.are_you_sure',
    action: 'Yes!',
    actionIntl: 'button.yes',
    cancelActionIntl: 'button.cancel',
    closeAction: 'Cancel'
  }

  state = {
    y: -100,
    opacity: 0,
    z: -2000,
    darkOverlay: true,
    shouldClose: false
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.alertObj.id !== nextProps.alertObj.id &&
      !nextProps.alertObj.id
    ) {
      this.handleOnRequestClose()
    }
  }

  componentWillUnmount() {
    this.handleClose()
  }

  handleOnRequestClose = () => {
    this.setState(
      {
        y: -100,
        opacity: 0,
        z: -2000,
        shouldClose: true
      },
      () => {
        this.handleClose()
      }
    )
  }

  handleClose = () => {
    if (this.props.onClose) {
      this.props.onClose()
    }
    this.props.alert(null, null)
  }

  handleAfterOpen = () => {
    this.setState({
      y: 0,
      opacity: 1,
      z: 0,
      shouldClose: false
    })
  }

  handleAfterSubmit = () => {
    if (this.props.onSubmit) {
      this.props.onSubmit()
    }

    this.props.alert(null, null)
  }

  render() {
    const {
      id,
      text,
      action,
      alertObj,
      closeAction,
      intlKey,
      actionIntl,
      cancelActionIntl
    } = this.props
    const { y, z, opacity } = this.state

    return (
      <ReactModal
        isOpen={alertObj.id === id}
        style={resetStyles}
        className="modal-content"
        onAfterOpen={this.handleAfterOpen}
        closeTimeoutMS={380}
        contentLabel={this.props.contentLabel}
      >
        <Motion
          defaultStyle={{ y, z, opacity }}
          style={{
            y: spring(y, { stiffness: 65, damping: 13 }),
            opacity: spring(opacity, { stiffness: 65, damping: 13 }),
            z: spring(z)
          }}
        >
          {interpolatingStyle => (
            <div
              className={styles.modalContent}
              style={{
                transform: `translate3d(0, ${interpolatingStyle.y}px, ${interpolatingStyle.z}px)`,
                opacity: `${interpolatingStyle.opacity}`
              }}
            >
              <div className={styles.innerContent}>
                <p className={styles.text}>
                  <FormattedMessage id={intlKey} defaultMessage={text} />
                </p>
                <div className={styles.btns}>
                  <div className={styles.btn}>
                    <button
                      type="button"
                      className={styles.close}
                      onClick={this.handleOnRequestClose}
                    >
                      <FormattedMessage
                        id={cancelActionIntl}
                        defaultMessage={closeAction}
                      />
                    </button>
                  </div>
                  <div className={styles.btn}>
                    <ElevatedButton
                      uppercase
                      rounded
                      submit
                      intlKey={actionIntl}
                      onClick={this.handleAfterSubmit}
                    >
                      {action}
                    </ElevatedButton>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Motion>
      </ReactModal>
    )
  }
}

export default Alert
